import React, { useState } from "react";
import Input from "../common/Input";
import { IconSave } from "../icons/Icons";
import ButtonPrimaryForm from "../common/ButtonPrimaryForm";
import TextArea from "../common/TextArea";

const VideosForm = () => {
  const [formData, setFormData] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  };

  const handleFileChange = async (event) => {
    const fileData = event.target.files[0];
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="grid grid-cols-1 gap-x-10 gap-y-2 mt-4 items-end">
        <Input
          textLabel={"Fecha"}
          typeInput={"date"}
          name={"fecha"}
          className="w-3/4"
          required={true}
          value={formData.fecha}
          onChange={handleInputChange}
        />
        <TextArea
          textLabel={"Descripción"}
          name={"descripcion"}
          className="w-3/4"
          required={true}
          value={formData.descripcion}
          onChange={handleInputChange}
        />
        <div>
          <label
            htmlFor="videoFile"
            className="block text-sm font-medium text-gray-700"
          >
            Subir archivo
          </label>
          <input
            type="file"
            id="videoFile"
            name="video_files"
            // accept=".pdf"
            // multiple
            onChange={handleFileChange}
            className="mt-1 p-2 border border-gray-300 rounded-md"
          />
        </div>
      </div>
      <div className="flex justify-between items-center gap-2 mt-6">
        <div className="flex flex-col gap-2">
          <span className="text-red-500 text-xs italic">
            * Campos obligatorios
          </span>
        </div>
        <div className="flex gap-2 items-center">
          <ButtonPrimaryForm text={"Guardar"} typeBtn={"submit"}>
            <IconSave className="w-4" />
          </ButtonPrimaryForm>
        </div>
      </div>
    </form>
  );
};

export default VideosForm;
